import { render, staticRenderFns } from "./TabPanes.vue?vue&type=template&id=3a323629&"
import script from "./TabPanes.vue?vue&type=script&lang=js&"
export * from "./TabPanes.vue?vue&type=script&lang=js&"
import style0 from "./TabPanes.vue?vue&type=style&index=0&id=3a323629&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports